<template>
    <div class="editable-text">
        <editable :value.sync="value"
                  :placeholder="placeholder"
                  :display-value="displayValue"
                  :display-value-is-html="true"
                  :has-value="hasValue"
                  :valid="valid">
            <div slot="editor"
                 class="number-input">
                <input type="text"
                       @input="resize"
                       @keyup.enter="validate"
                       v-model="rawValue"
                       :placeholder="placeholder">
                <span>{{ addon }}</span>
            </div>
        </editable>
    </div>
</template>

<style scoped
       lang="less">
    @import './variables';

    @border-size: 1px;

    .editable-text {
        display: inline-block;
    }

    input {
        border: 0;
        background-color: @color-edit;
        box-sizing: content-box;
        margin: -@border-size 0;
        padding: 0 @border-size;

        &:focus {
            outline: @border-size solid @color-hover;
        }
    }
</style>

<script type="text/ecmascript-6">
    import Editable from './Editable';
    import Vue from 'vue';

    export default {
        components: {
            Editable
        },
        props: {
            value: {
                twoWay: true
            },
            placeholder: {
                'default': 'Éditer...'
            },
            addon: {
                'default': '€'
            }
        },
        data() {
            return {
                rawValue: ''
            };
        },
        computed: {
            editValue() {
                const val = this.rawValue.replace(/\s+/g, '').replace(',', '.');

                if (/^[-+]?[0-9]*\.?[0-9]+$/.test(val)) {
                    return parseFloat(val);
                }
            },
            valid() {
                return this.editValue !== undefined || this.rawValue === '';
            },
            displayValue() {
                if (this.addon === '€') {
                    return Vue.options.filters.money(this.value, 0, true);
                } else if (this.addon === '%') {
                    return Vue.options.filters.percent(this.value);
                }
            },
            hasValue() {
                return typeof this.value === 'number';
            }
        },
        methods: {
            validate() {
                this.$broadcast('editable:validate');
            },
            resize() {
                const e = this.$el.querySelector('input');

                if (!e) {
                    return;
                }

                const rect = e.getBoundingClientRect();
                const innerWidth = e.clientWidth;
                const outerWidth = rect.width;

                const style = getComputedStyle(e);

                let extra = 0;
                extra += parseFloat(style['border-left-width']);
                extra += parseFloat(style['border-right-width']);
                extra += parseFloat(style['padding-left']);
                extra += parseFloat(style['padding-right']);

                e.style.width = '0';
                e.style.width = `${e.scrollWidth + outerWidth - innerWidth - extra}px`;
            }
        },
        events: {
            'editable:childStartEdition': function ({width}) {
                if (typeof this.value === 'number') {
                    this.rawValue = this.value.toLocaleString('fr-fr', {
                        style: 'decimal',
                        useGrouping: true,
                        maximumFractionDigits: 20
                    });
                }

                this.$nextTick(() => {
                    this.resize();
                    const input = this.$el.querySelector('input');
                    input.style.minWidth = `${width}px`;
                    input.select();
                });
            },
            'editable:childValidateEdition': function () {
                this.value = this.editValue;
            }
        }
    };
</script>



// WEBPACK FOOTER //
// EditableNumber.vue?52191c92